// import React from "react";
import bgimage from "../assets/banner-bg-4.png";
import "../App.scss";

const Home = () => {
  return (
    <>
      <section id="home" className="container-fluid container--home">
        <div className="section-width">
          <div className="card card--home p-0">
            <div className="card--home__content">
              <div className="col-md-6 hero-banner-text--wrapper">
                <h5 className="card-title banner-title">Learn from the best</h5>
                <h5 className="card-title banner-title mb-4">
                  At comfort of you home
                </h5>
                <p className="card-text banner-tagline-text">
                  Unlock your true potential with expert & experienced tutors,
                  who make education engaging.
                </p>
                <div className="btn-group banner-btn-wrapper mt-4">
                  <button className="banner--btn__cta">
                    Students Click Here
                  </button>
                  <button className="banner--btn__cta">
                    Teachers Click Here
                  </button>
                </div>
              </div>
              <div className="col-md-6 hero-banner-image--wrapper">
                <img
                  src={bgimage}
                  className="img-fluid hero-banner-image"
                  alt="gayatri-home-tuition-background-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Home;
